import { gql } from '@apollo/client'

import { EVENT_FRAGMENT } from '../../../common/graphql/fragments'

import { AWARD_NODE_FRAGMENT } from '../fragments'

const SAVE_AWARDS_MUTATION = gql`
  mutation saveAwards($data: [AwardNodeInput!]!) {
    saveAwards(data: $data) {
      results {
        ...AwardNodeFragment
      }
      latestEvent {
        ...EventFragment
      }
    }
  }
  ${AWARD_NODE_FRAGMENT}
  ${EVENT_FRAGMENT}
`

export default SAVE_AWARDS_MUTATION
